var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1PirSensibility220(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 38a3 3 0 01-3 3H12v-6h16a3 3 0 013 3zm27.41-21.82a2.5 2.5 0 10-3.54-3.53 2.5 2.5 0 003.54 3.53zm-6.78 1.65a2.5 2.5 0 10.953.186 2.49 2.49 0 00-.963-.186h.01zm-5 5.92a2.5 2.5 0 10.949.184 2.489 2.489 0 00-.969-.184h.02zm-5 5.92a2.5 2.5 0 10.94.18 2.489 2.489 0 00-.98-.18h.04zm-5 5.92a2.5 2.5 0 101.77.73 2.488 2.488 0 00-1.82-.74l.05.01zm5 5.89a2.5 2.5 0 10.94.18 2.489 2.489 0 00-.98-.18h.04zm5 5.89a2.5 2.5 0 10.949.184 2.489 2.489 0 00-.969-.184h.02zm5 5.89a2.5 2.5 0 10.953.186 2.49 2.49 0 00-.963-.186h.01zm5 5.89a2.5 2.5 0 10.01 0h-.01z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_PIR_sensibility_220.b34fba14.svg";
export { SvgG1PirSensibility220 as ReactComponent };